module.exports = __webpack_public_path__ + "img/04.f949063f.jpg";